import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Resx from '../Resx'
import { PropertyRenderer, RendererPropTypes, modes } from './propertyRenderer'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { FormContext } from '@/components/changeRequests/formContext'
import { PermissionSectionContext } from '@/components/changeRequests/permissionSectionContext'

function FormRowInternal (props) {
  return <InfoRow form={props.form}>
    <InfoLabel className={props.rejected ? 'danger' : ''}>{!props.checkBox && <Resx name={props.name} />}</InfoLabel>
    <InfoContent className={props.props.preText && 'pre-text'} >
      <PropertyRenderer {...props.props} title={props.checkBox ? props.name : null} />
    </InfoContent>
  </InfoRow>
}

FormRowInternal.propTypes = {
  form: PropTypes.bool,
  checkBox: PropTypes.bool,
  name: PropTypes.string,
  props: PropTypes.any,
  rejected: PropTypes.bool,
  preText: PropTypes.bool
}

export function FormRow ({ label, ...props }) {
  const value = useContext(FormContext)
  const isReadOnly = useContext(PermissionSectionContext)

  const isCheckBox = props.inputType === 'checkbox' && value.mode === modes.edit
  const form = !props.readonly && value.mode === modes.edit
  const readonly = isReadOnly || props.readonly

  return <FormRowInternal form={form} checkBox={isCheckBox} name={label} props={{ ...props, readonly }} />
}

FormRow.propTypes = {
  ...RendererPropTypes,
  label: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/formRow.js